<div class="pull-up-wrapper">
  <div class="line"></div>
  <div class="title-pull-up" *ngIf="typePopup === 'tool-tip-payment'">
    Cách tính cước Internet bổ sung
  </div>
  <div class="content-pull-up">
    <div class="list-item-wrapper" *ngIf="typePopup === 'tool-tip-payment'">
      <div class="item-in-list">
        <div class="title-item">Gói cước hiện tại</div>
        <div class="content-item">
          <div>
            <span class="text-bold">{{
              dataPopup?.addition_detail.current_data?.data_name
            }}</span>
          </div>
          <div>
            <span class="text-bold"
              >{{ dataPopup?.addition_detail.current_data?.duration }}
            </span>
            {{ dataPopup?.addition_detail.current_data?.time }}
          </div>
        </div>
      </div>
      <div class="item-in-list">
        <div class="title-item">Gói cước mới</div>
        <div class="content-item">
          <div>
            <span class="text-bold"
              >{{ dataPopup?.addition_detail.new_data?.data_name }}
            </span>
            ({{ dataPopup?.addition_detail.new_data?.description }}
            )
          </div>
        </div>
      </div>
      <div class="item-in-list">
        <div class="title-item">Thời điểm tính cước mới</div>
        <div class="content-item">
          <div>
            <span class="text-bold">{{
              dataPopup?.addition_detail.t_apply
            }}</span>
          </div>
        </div>
      </div>
      <div class="item-in-list">
        <div class="title-item">Tiền trả trước thu tăng thêm</div>
        <div class="content-item">
          <div>
            <span class="text-bold">{{
              dataPopup?.addition_detail.addition_price.fee_str
            }}</span>
          </div>
          <div>{{ dataPopup?.addition_detail.addition_price.time }}</div>
        </div>
      </div>
    </div>
    <button
      *ngIf="typePopup === 'tool-tip-payment'"
      class="payment-info-button"
      (click)="closePopup()"
    >
      Đã hiểu
    </button>
    <div class="date-list" *ngIf="typePopup === 'date-picker'">
      <a
        class="date-item"
        *ngFor="let itemDate of dateList"
        [ngClass]="selectedDate == itemDate.appointment_date ? 'active' : ''"
        (click)="handleChangeDate(itemDate)"
      >
        <span>{{ itemDate.day }}</span>
        <span>{{ itemDate.date }}</span>
      </a>
    </div>
    <div class="time-list" *ngIf="typePopup === 'date-picker'">
      <div class="item" *ngFor="let item of listTime">
        <div class="wrapper">
          <input
            type="radio"
            id="{{ item?.time_slot }}"
            value="{{ item?.time_slot }}"
            name="radio-group"
            [(ngModel)]="firstTime"
            (ngModelChange)="handleChangeTime(item)"
            [attr.disabled]="item.is_available === false ? true : null"
          />
          <label for="{{ item.time_slot }}">{{ item.text }}</label>
        </div>
      </div>
    </div>
  </div>
</div>
